<header>
  <video id="my_video_1" class="ticket-video" width="1920" playsinline no-controls onloadedmetadata="this.muted = true" oncanplay="play()">
    <source class="video_source" type="video/mp4" src="/assets/video/hejvenner-bg-slowmo-1920x1080.mp4">
    <p>Your browser cannot play the provided video file.</p>
  </video>

  <p class="pligt-txt text-end">Hver gevinst over 200 kr. fratrækkes <br>gevinstafgift på 15 % inden udbetaling.</p> 

  <div class="content container-fluid">
    <div class="row">  
        <div class="text-kl-red text-center mx-auto">  
          <h1 id="splitit" class="kl-display-1 txt1">
            MILLIONPAKKEN
          </h1>
          <div class="lodpakke">
            <img class="img-fluid" src="/assets/images/forside_hero/miopakke.png" alt="Milllionpakken lodpakke">
          </div>
          <div class="lodpakke2">
            <img class="img-fluid" src="/assets/images/forside_hero/miopakke.png" alt="Milllionpakken lodpakke">
          </div>
          <div id="" class="kl-display-2 text-kl-white txt4">
            vind op til
          </div>
          <div class="kl-display-3 text-kl-red txt5">
            1.000.000 kr.
          </div>
        </div>
        <div id="split_2" class="dis-num text-kl-red txt2">
          88<span class="disp-small">%</span>
        </div>
        <div class="text-kl-white txt3 sub">
          i årlig<br> vinderchance
        </div> 
    </div>
    <div class="cta mx-auto text-kl-white text-center">
      <button *ngIf="showCTA" (click)="redirectToShop()" type="button" class="btn btn-kl-red btn-lg mb-3 pulse">KØB HER</button>
    </div>  
  </div>
</header>